import type { FunctionComponent } from 'react';

import type { ISingleHistoryGame } from '../../../../../../api/fetchers/history/types';
import { Card, CardSuite, CardValue } from '../../../../../game/card/card';
import { L12nText } from '../../../../../text/L12nText';

import styles from './TopCardResultMessage.module.css';

export const TopCardResultMessage: FunctionComponent<{ game: ISingleHistoryGame }> = ({ game }) => {
  const { newResultCode, cardValues } = game.simulated;

  const cardItemsArray = newResultCode.split(',');
  const cardValuesArray = cardValues?.replace(/\w+:\s?(\d+)/g, '$1').split(',');
  if (!cardItemsArray || !cardValuesArray) {
    return null;
  }

  const [homeScore, awayScore] = cardValuesArray;
  const [homeItem, awayItem] = cardItemsArray;

  const homeCard = cardConverter(homeItem);
  const awayCard = cardConverter(awayItem);

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <L12nText tk="TOPCARD_HOME_CAPS" />: {homeScore}
        <Card className={styles.card} suite={homeCard.suite} value={homeCard.value} />
      </div>
      <div className={styles.right}>
        <L12nText tk="TOPCARD_AWAY" />: {awayScore}
        <Card className={styles.card} suite={awayCard.suite} value={awayCard.value} />
      </div>
    </div>
  );
};

const cardConverter = (
  card: string
): {
  suite: CardSuite;
  value: CardValue;
} => {
  const value: CardValue = card[0] == '0' ? ('10' as CardValue) : (card[0] as CardValue);
  switch (card[1]) {
    case 'S':
      return { value, suite: CardSuite.Spades };
    case 'H':
      return { value, suite: CardSuite.Hearts };
    case 'D':
      return { value, suite: CardSuite.Diamonds };
    case 'C':
    default:
      return { value, suite: CardSuite.Clubs };
  }
};
